import { startOfMonth } from 'date-fns';
import { createContext, useContext, useState } from 'react';

const ReportContext = createContext();

const initialState = {
  selectedTab: 'brand',
  errorProps: {},
};

const getInitialFilterState = () => {
  const now = new Date();
  const startedAt = startOfMonth(now);
  const endedAt = now;
  return {
    page: 1,
    limit: 10,
    search: null,
    sort: null,
    brand: { startedAt, endedAt, brand: null },
    host: { startedAt, endedAt, brand: null },
    session: { startedAt, endedAt, brand: null, account: null, platform: null },
    accountPlatform: { startedAt, endedAt, brand: null, account: null, platform: null, accountType: null },
  };
};

const ReportProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(getInitialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState(getInitialFilterState);

  return (
    <ReportContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, state, filterState }}>{children}</ReportContext.Provider>
  );
};

export const useReportState = () => {
  return useContext(ReportContext);
};

export default ReportProvider;
